"use strict";

exports.__esModule = true;
exports.autocompleteValidator = exports.VALIDATOR_TYPE = void 0;
var _autocompleteValidator = require("./autocompleteValidator");
exports.VALIDATOR_TYPE = _autocompleteValidator.VALIDATOR_TYPE;
exports.autocompleteValidator = _autocompleteValidator.autocompleteValidator;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/autocompleteValidator/index.js
// module id = 371
// module chunks = 0